<script>
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";

    onMount(() => {
        if (window.localStorage.getItem("token") === null) {
            push("/login");
        }
    });
</script>
